import { deleteBrowserCookie } from '@backmarket/utils/cookies/deleteBrowserCookie'
import { getBrowserCookie } from '@backmarket/utils/cookies/getBrowserCookie'
import { setBrowserCookie } from '@backmarket/utils/cookies/setBrowserCookie'
import { v4 as uuid } from 'uuid'

import {
  SIGNIFYD_COOKIE_MAX_AGE,
  SIGNIFYD_COOKIE_NAME,
} from '../config/signifyd/constants'

/**
 * > The session ID is a random string that is unique to each checkout on your online store, not the user's browsing session.
 * > https://developer.signifyd.com/ecommerce-integration-guide/fingerprinting/#generate-session-id
 */
export const getOrSetSignifydSessionId = () => {
  const sessionId = getBrowserCookie(SIGNIFYD_COOKIE_NAME)
  if (sessionId) {
    return sessionId
  }

  const newSessionId = uuid()
  setBrowserCookie(SIGNIFYD_COOKIE_NAME, newSessionId, {
    maxAge: SIGNIFYD_COOKIE_MAX_AGE,
    path: '/',
  })

  return newSessionId
}

export const resetSignifydSessionId = () => {
  deleteBrowserCookie(SIGNIFYD_COOKIE_NAME)
}
